import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { color as colorTokens } from '@spotify-internal/encore-foundation';
import { TypeElement, variants, weights } from "./Type";

function isColorToken(color) {
  return color !== undefined && colorTokens.hasOwnProperty(color);
}

var TypeComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body2' : _ref$variant,
      props = _objectWithoutProperties(_ref, ["color", "variant"]);

  return /*#__PURE__*/React.createElement(TypeElement, Object.assign({
    variant: variant,
    typeColor: isColorToken(color) ? colorTokens[color] : color,
    ref: ref
  }, props));
}); // export components

export var elements = {
  h1: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h1",
      ref: ref
    }, props));
  }),
  h2: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h2",
      ref: ref
    }, props));
  }),
  h3: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h3",
      ref: ref
    }, props));
  }),
  h4: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h4",
      ref: ref
    }, props));
  }),
  h5: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h5",
      ref: ref
    }, props));
  }),
  h6: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h6",
      ref: ref
    }, props));
  }),
  p: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "p",
      ref: ref
    }, props));
  }),
  small: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "small",
      ref: ref
    }, props));
  }),
  li: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "li",
      ref: ref
    }, props));
  }),
  span: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "span",
      ref: ref
    }, props));
  })
};

var typeHelpers = _objectSpread(_objectSpread(_objectSpread({}, elements), variants), weights);

export var Type = Object.assign(TypeComponent, typeHelpers);
export default Type;